import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { globalFontStyle } from '../../../assets';
import { globalConfigurableData } from '../../../utils/globalConstant';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import moment from 'moment';
import { currencyConverter, timeLagFromCurrentTime } from '../../../utils/commonMethods';
import RupeeVal from '../../../commonComponents/RupeeVal';

const AboutEvent = ({ eventDetails, _eventInfo }) => {
  const endTime = moment.utc(_eventInfo?.endsat).local().format('MMMM DD, YYYY hh:mm a');
  const settleTime = moment.utc(_eventInfo?.settledate).local().format('MMMM DD, YYYY hh:mm a');
  const startTime = moment.utc(_eventInfo?.start_date).local().format('MMMM DD, YYYY hh:mm a');

  const renderDetailRow = (label, value, isRupee = false) => {
    if (value === undefined || value === null) return null;
    return (
      <View style={styles.detailRow}>
        <FormTextLabel
          labelStyles={styles.label}
          label={label}
        />
        {isRupee ? (
          <RupeeVal
            rupeeVal={currencyConverter(value)}
            customStyle={styles.value}
          />
        ) : (
          <Text style={styles.value}>{value}</Text>
        )}
      </View>
    );
  };

  return (
    <View style={styles.container}>
      {_eventInfo?.endsat && renderDetailRow('Ends in', timeLagFromCurrentTime(_eventInfo?.endsat, true))}
      {eventDetails?.volume !== undefined && renderDetailRow('Trading Volume', eventDetails?.volume, true)}
      {/* {_eventInfo?.number_of_traders !== undefined && renderDetailRow('Traders', _eventInfo?.number_of_traders)} */}
      {_eventInfo?.start_date && renderDetailRow('Opened on', startTime)}
      {_eventInfo?.endsat && renderDetailRow('Closes on', endTime)}
      {_eventInfo?.settledate && renderDetailRow('Settlement on', settleTime)}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
  },
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  label: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
  },
  value: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
  },
});

export default AboutEvent;
